import React from 'react';
 
import KeeVue from '../base/KeeVue.js'
 
import FeasComponent from './FeasComponent.js'
 
import $ from 'jquery';
 
//props: ['components','cpstyle', 'parentLayout', 'po', 'name', 'query', 'debug', 'thisForm', 'parentForm', 'editable'],

export default class FeasComponents extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			randId: this.getRandString(),
		};

	}

	componentWillMount() {}
   
	// 向上传递命令
	onCommand=(cmdName, item, po, thisForm, parentForm)=>{
				//console.log(" 收到command事件：" + cmdName);
				if(cmdName == 'remove') {
	
					this.props.components.remove(thisForm);
	
				}
	
				if(cmdName == 'add') {
					//this.components.push(item);
				} else {
					//console.log("向上传递command")
					this.$emit("command", cmdName, item, po, thisForm, parentForm);
				}
	
			}
	onChanged=(ret)=> {
				this.$emit("changed", ret);
			}
	
	 componentWillReceiveProps(nextProps){
		   //this.setState(this.state);
		 }

	render() {
		
		//console.log("props:",this.props.thisForm); style={{height:(item.name=='fs-layout'?'100%':'auto')}}
		
		if(this.props.components&&this.props.components.length>0)
		{
			 
		
	 
		return this.props.components.map((item,index)=>{
			
			//console.log("重绘："+this.props.editable)
			
			return  <FeasComponent   key={item.id+index}   component={item}  po={this.props.po} keePage={this.props.keePage}  thisForm={this.props.thisForm} 
				 
		query={this.props.query} 
		editable={this.props.editable} 
		onChanged={this.onChanged}
		onCommand={this.onCommand}
		onChildRefresh={()=>{ this.$emit("childRefresh")}}
		debug={this.props.debug} ></FeasComponent>  
			
						 
		})
		
			
		 
		
		}
		else
		{
			return <div > </div>
		}
		
		
		

	}
}
